import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * A configured ERP submission API the sales-order Submission step can target.
 * `builtin:*` entries are the code adapters (available when their module is
 * enabled); registered entries are schema-mapped ExternalApiDefinitions with
 * kind "erp_submission" (later phase).
 */
export const ErpSubmissionApiSchema = z.object({
  /** "builtin:oracle-ebs" | "builtin:oracle-fusion" | ExternalApiDefinition id. */
  id: z.string(),
  name: z.string(),
  kind: z.enum(["builtin", "registered"]),
});

export type ErpSubmissionApi = z.infer<typeof ErpSubmissionApiSchema>;

export const erpSubmissionApiContracts = {
  /**
   * Auto-discovers the organization's configured ERP submission APIs —
   * populates the Submission step's target dropdown.
   */
  list: oc
    .input(z.object({}))
    .output(z.object({ apis: z.array(ErpSubmissionApiSchema) }))
    .route({
      method: "GET",
      summary: "List ERP order submission targets",
      description:
        "Returns the ERP submission targets a sales-order submission step can use: built-in adapters for enabled ERP modules plus active registered submission APIs.",
    }),
} as const;
